// Lazy Loading - CTRL IA
// Carrega imagens apenas quando aparecem na tela

(function() {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    console.log('Lazy loading não suportado');
    return;
  }

  const observerConfig = {
    root: null,
    rootMargin: '50px',
    threshold: 0.01
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const src = img.dataset.src;
        const srcset = img.dataset.srcset;
        
        if (src) img.src = src;
        if (srcset) img.srcset = srcset;
        
        img.classList.add('loaded');
        observer.unobserve(img);
      }
    });
  }, observerConfig);

  function init() {
    const images = document.querySelectorAll('img[data-src]');
    images.forEach(img => observer.observe(img));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
